import ApiService from "@/common/api.service";

export const MfrService = {
    async getRegions(params) {
        return ApiService.get(`/mfr/regions${params}`);
    },
    async getTrees(params) {
        return ApiService.get(`/mfr/trees${params}`);
    },
    async getFacilities(params) {
        return ApiService.get(`/mfr/facilities${params}`);
    },
    async createFacility(params) {
        return ApiService.post(`/mfr/facilities`, params);
    },


    //drp
    async getRegionsDrp() {
        return ApiService.get(`/mfr/regions/drp`);
    },
    async getZonesDrp(id) {
        const suffix = id ? `?regionId=${id}` : "";
        return ApiService.get(`/mfr/zones/drp${suffix}`);
    },
    async getWoredasDrp(id) {
        const suffix = id ? `?zoneId=${id}` : "";
        return ApiService.get(`/mfr/woredas/drp${suffix}`);
    },
    async getFacilitiesDrp(id) {
        const suffix = id ? `?woredaId=${id}` : "";
        return ApiService.get(`/mfr/facilities/drp${suffix}`);
    },
};
